import styled from "styled-components"
import { useSelector } from "react-redux"

import usePushConfig from "hooks/mypage/usePushConfig"

import PushConfigCategorySection from "./PushConfigCategorySection"
import PushConfigItem from "./PushConfigItem"

export default function PushConfigSetting() {
  const { id } = useSelector((state) => state.userInfo)
  const { pushConfigData, isLoading, handleChangePushConfig } = usePushConfig({ userNo: id })

  if (isLoading || !pushConfigData) return null
  return (
    <PushConfigList>
      <PushConfigCategorySection title="소통 알림" iconName="speechBubble">
        <PushConfigItem
          title="좋아요, 댓글 알림"
          desc="내 글에 좋아요, 댓글 알림"
          name="feed_alarm"
          isChecked={
            !!(
              pushConfigData.task_like &&
              pushConfigData.task_comment &&
              pushConfigData.task_comment_reply
            )
          }
          onChange={handleChangePushConfig}
        />
        <PushConfigItem
          title="커뮤니알림"
          desc="커뮤니티 새 게시글, 좋아요, 댓글 알림"
          name="community_alarm"
          isChecked={
            !!(
              pushConfigData.community_post_new &&
              pushConfigData.community_post_like &&
              pushConfigData.community_post_comment &&
              pushConfigData.community_post_comment_reply
            )
          }
          onChange={handleChangePushConfig}
        />
      </PushConfigCategorySection>
      <PushConfigCategorySection title="챌린지 알림" iconName="flag">
        <PushConfigItem
          title="인증 알림"
          desc="인증 까먹을 시, 알림"
          name="task_alarm"
          isChecked={!!pushConfigData.task_alarm}
          onChange={handleChangePushConfig}
        />
        <PushConfigItem
          title="새로운 챌린지 알림"
          desc="새로운 챌린지 개설 시, 알림"
          name="new_challenge"
          isChecked={!!pushConfigData.new_challenge}
          onChange={handleChangePushConfig}
        />
      </PushConfigCategorySection>
      <PushConfigCategorySection title="모티벨 퀴즈 알림" iconName="bell">
        <PushConfigItem
          title="모티벨 퀴즈 알림"
          desc="오늘의 퀴즈 알림"
          name="quiz_alarm"
          isChecked={!!pushConfigData.quiz_alarm}
          onChange={handleChangePushConfig}
        />
      </PushConfigCategorySection>
      <PushConfigCategorySection title="서비스 알림" iconName="loudSpeaker">
        <PushConfigItem
          title="새로운 이벤트 알림"
          desc="중요한 이벤트 소식 알림"
          name="new_event"
          isChecked={!!pushConfigData.new_event}
          onChange={handleChangePushConfig}
        />
        <PushConfigItem
          title="마케팅 및 정보성 알림"
          desc="마케팅 정보 알림"
          name="marketing_info"
          isChecked={!!pushConfigData.marketing_info}
          onChange={handleChangePushConfig}
        />
      </PushConfigCategorySection>
    </PushConfigList>
  )
}

const PushConfigList = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`
